$(window).on('load resize', function () {
    var pos = ($(window).width() < 992) ? 'left' : 'top';
    if ($('[data-toggle="tooltip"]').tooltip) {
        $('[data-toggle="tooltip"]').tooltip({'placement': pos});
    }
}).trigger('resize');

const nav = document.querySelector('.my-navigation');
const getSubNavButton = document.querySelector('.my-navigation .get-sub-nav');
if (nav) {
    const li = nav.querySelectorAll('li:not(.more)');
    const liMORE = nav.querySelector('li.more');
    const subNav = document.getElementById('sub-menu');
    if (li.length > 3) {
        liMORE.style.display = 'inline-block';

        for (let i = 0; i < li.length; i += 1) {
            if (i > 2) {
                let lis = document.createElement('li');
                lis.innerHTML = li[i].innerHTML;
                subNav.append(lis)
                li[i].parentNode.removeChild(li[i]);
            }
        }
    }
}

window.onload = function () {
    const closeMenu = function () {
        const $target = $(event.target);

        if (!$target.closest('#user-profile-nav').length) {
            $('#user-profile-nav').removeClass('active');
            $('#getUserNav').removeClass('active-button');

            $('body').unbind('click', closeMenu);
        }
    };

    let getUserNav = document.getElementById('getUserNav');
    if (getUserNav) {
        getUserNav.addEventListener('click', (e) => {
            e.preventDefault();
            e.target.classList.toggle('active-button');
            let userNav = document.getElementById('user-profile-nav');
            if (userNav) userNav.classList.toggle('active');

            setTimeout(function () {
                $('body').click(closeMenu);
            }, 0);
        })
    }
}
